const config = {
    basename: '',
    defaultPath: '/dashboard',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 12,
    API_SERVER: 'https://sija.cybearstribe.com/api/'
};

export default config;
